export const asSlug = (text = '') => {
    return text
        .trim()
        .toLowerCase()
        .replace(/[\W_]+/g, '-')
        .replace(/^-+|-+$/g, '');
};
